"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_TEXT = void 0;
exports.EMPTY_TEXT = {
    dash: '—',
    na: 'n/a',
    naUpperCase: 'N/A',
};
//# sourceMappingURL=emptyText.js.map